import * as React from 'react';
import { PaletteMode, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import NavbarBack from '../../NavbarBack';
import DetailCidContainer from '../container/detailCidContainer';
import getLPTheme, { black, white } from '../../../../../getLPTheme';
import Link from '@mui/material/Link';
import Copyright from '../../../../../auxiliares/Copyright';

  
  export default function DetailPid() {
    const [mode] = React.useState<PaletteMode>('dark');  // Cambiar a 'ligh' para que empiece con tema claro.
    const [showCustomTheme] = React.useState(true);
    const LPtheme = createTheme(getLPTheme(mode));
    const defaultTheme = createTheme({ palette: { mode } });
  
    return (
      <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
        <CssBaseline />
        <NavbarBack/>
        <Box sx={{ mt:10, bgcolor: 'background.default' }}>
          <DetailCidContainer />
        </Box>
        <Box component="footer" sx={{ p: 2, bgcolor: black[1000] }}>
          <Copyright />
        </Box>
      </ThemeProvider>
    );
  }
